import { formatCurrencyRound } from '../../utils/formatters.util';
import React, { memo } from 'react';

const BulkPricingMSRP = ({ pricing, uomData }) => {
  return (
    <div>
      <table className='tw:w-full tw:text-body tw:text-xs'>
        <thead>
          <tr className='tw:w-full tw:border-b tw:border-[#d3d3d3] tw:last:border-b-0'>
            <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-left'></th>
            <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-center'>Price to Team</th>
            <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-center'>MSRP</th>
            <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-right'>Team Earns</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(pricing).map(([k, rule], i) => (
            <tr key={i} className='tw:w-full tw:border-b tw:border-[#d3d3d3] tw:last:border-b-0'>
              <td className={'tw:capitalize tw:py-1 tw:text-left'}>{k}</td>
              <td className='tw:py-1 tw:text-center'>
                {formatCurrencyRound(rule[0].rates[0].rate / (uomData.isCase ? uomData.conversion : 1))}
              </td>
              <td className='tw:py-1 tw:text-center'>
                {formatCurrencyRound(rule[0].rates[0].msrp / (uomData.isCase ? uomData.conversion : 1))}
              </td>
              <td className='tw:py-1 tw:text-right'>
                {formatCurrencyRound(
                  (rule[0].rates[0].msrp - rule[0].rates[0].rate) / (uomData.isCase ? uomData.conversion : 1)
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(BulkPricingMSRP);
